module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_sp_banner01-09329685f1d6a7dfb36cabdee979139e.jpg";